interface Props {
  onClose: () => void;
}

export const LightBoxSuccessState = ({ onClose }: Props) => {
  return (
    <div className="flex flex-col gap-4 p-4 pt-10 lg:p-10 justify-center">
      <p className="font-['Poppins'] font-bold text-xl leading-6 tracking-normal text-center align-middle text-[#1A1A1A] max-w-[307px] lg:max-w-[351px]">Cadastro realizado com sucesso.</p>
      <p className="font-['Poppins'] font-normal text-base leading-6 tracking-normal text-center align-middle text-[#1A1A1A] max-w-[307px] lg:max-w-[351px]">Agora você vai receber novidades e descontos exclusivos no seu e-mail.</p>
      <button
        onClick={onClose}
        className="font-['Poppins'] font-bold text-base leading-[17px] tracking-normal text-center align-middle uppercase text-white w-full py-4 mt-4 bg-[#1E1E1E] border-none cursor-pointer max-w-[307px] lg:max-w-[351px] hover:bg-[#C18A58] hover:text-[#1A1A1A]"
      >
        Continuar Comprando
      </button>
    </div>
  );
}
